<template>
	<div></div>
</template>

<script>
    export default {
        mounted() {
            if (this.$isMobile()) {
                this.$router.push({ name: 'dice' });
            } else {
                this.$router.push({ name: 'slots' });
            }
        }
    }
</script>